(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeCards', PropriedadeCards);

  function PropriedadeCards() {
    return {
      restrict: 'E',
      controller: 'PropriedadeCardsCtrl',
      controllerAs: 'cards',
      templateUrl: 'views/propriedade/propriedade-cards.html',
      scope: {
        filters: '<',
        culturasPorGleba: '<',
        isHistorico: '<',
        unreadHistories: '<'
      }
    };
  }

}());
